const sizes: { [size: string]: number } = {
  xxl: 64, // special cases like logos
  xl: 34, // special cases (not used yet)
  large: 24, // special cases
  normal: 18,
  medium: 18,
  small: 16,
  xsmall: 10 // special cases
};

export { sizes };
